/* Product Page 2026 — image zoom for the pp-hero-2026 gallery.
 *
 * Desktop (hover + fine pointer): Amazon-style hover zoom. A lens follows the
 * cursor over the selected slide and a pane beside the gallery (over the buy
 * card) shows that area magnified from a high-res copy. Below the two-column
 * breakpoint the pane covers the slide itself instead.
 * Every device: a tap/click on the slide (or the magnifier button) opens a
 * full-screen viewer — pinch, double-tap and wheel zoom, drag to pan.
 *
 * Always works on the slide Flickity has selected, so thumbnails, swipes and the
 * variant picker all keep driving which image is zoomed. Called from the hero's
 * inline script as window.ppZoom(root, galleryEl, flkty). Images opt in through
 * img[data-zoom-src]; video / 3D slides are skipped. */
(function () {
  if (window.ppZoom) return;

  var HOVER_MIN = 2, HOVER_MAX = 3.5;   // hover magnification range
  var VIEW_MAX = 4, VIEW_TAP = 2.5;     // viewer: max zoom, double-tap zoom

  var hiRes = {};                        // zoom-src -> loaded?
  function loadHiRes(url, done) {
    if (hiRes[url]) { done(); return; }
    var im = new Image();
    im.onload = function () { hiRes[url] = true; done(); };
    im.src = url;
  }

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ── Hover zoom (desktop) ─────────────────────────────────────────────── */
  function bindHover(root, galleryEl, flkty) {
    var gallery = galleryEl.parentNode;            // .pp-hero__gallery (position: relative)
    var media = root.querySelector('.pp-hero__media');
    var lens = document.createElement('div');
    lens.className = 'pp-zoom__lens';
    lens.setAttribute('aria-hidden', 'true');
    var pane = document.createElement('div');
    pane.className = 'pp-zoom__pane';
    pane.setAttribute('aria-hidden', 'true');
    gallery.appendChild(lens);
    gallery.appendChild(pane);

    var twoCol = window.matchMedia('(min-width: 1025px)');
    var active = null, dragging = false, last = null;

    function hide() {
      active = null;
      lens.classList.remove('is-on');
      pane.classList.remove('is-on');
      if (media) media.classList.remove('is-zooming');
    }

    function currentImg() {
      var cell = flkty.selectedElement;
      return cell && cell.querySelector('img[data-zoom-src]');
    }

    function update(e) {
      if (dragging) return;
      var img = currentImg();
      if (!img) { hide(); return; }
      var r = img.getBoundingClientRect();
      if (!r.width || e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { hide(); return; }

      var g = gallery.getBoundingClientRect();
      var main = galleryEl.getBoundingClientRect();
      var side = twoCol.matches;

      if (active !== img) {
        active = img;
        var url = img.getAttribute('data-zoom-src');
        pane.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
        loadHiRes(url, function () { if (active === img) pane.style.backgroundImage = 'url("' + url + '")'; });
        pane.classList.toggle('is-inner', !side);
      }

      // Pane geometry: beside the gallery (2-col) or over the slide itself.
      var pw, ph, pl, pt;
      if (side) {
        pl = main.width + 24;
        pw = Math.min(main.width, window.innerWidth - (g.left + pl) - 16);
        ph = main.height;
        pt = main.top - g.top;
      } else {
        pl = main.left - g.left; pt = main.top - g.top; pw = main.width; ph = main.height;
      }
      if (pw < 160) { hide(); return; }

      var natural = parseFloat(img.getAttribute('data-zoom-width')) || img.naturalWidth || r.width;
      var scale = clamp(natural / r.width, HOVER_MIN, HOVER_MAX);

      // Lens = the slice of the image the pane can show, centred on the cursor.
      var lw = Math.min(pw / scale, r.width), lh = Math.min(ph / scale, r.height);
      var lx = clamp(e.clientX - r.left - lw / 2, 0, r.width - lw);
      var ly = clamp(e.clientY - r.top - lh / 2, 0, r.height - lh);

      var ps = pane.style, ls = lens.style;
      ps.left = pl + 'px'; ps.top = pt + 'px'; ps.width = pw + 'px'; ps.height = ph + 'px';
      ps.backgroundSize = (r.width * scale) + 'px ' + (r.height * scale) + 'px';
      ps.backgroundPosition = (-lx * scale + (pw - lw * scale) / 2) + 'px ' + (-ly * scale + (ph - lh * scale) / 2) + 'px';
      ls.left = (r.left - g.left + lx) + 'px'; ls.top = (r.top - g.top + ly) + 'px';
      ls.width = lw + 'px'; ls.height = lh + 'px';
      lens.classList.toggle('is-on', side);
      pane.classList.add('is-on');
      if (media) media.classList.add('is-zooming');
    }

    galleryEl.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      last = e;
      update(e);
    });
    galleryEl.addEventListener('pointerleave', function () { last = null; hide(); });
    window.addEventListener('scroll', function () { if (last && active) update(last); }, { passive: true });
    flkty.on('dragStart', function () { dragging = true; hide(); });
    flkty.on('dragEnd', function () { dragging = false; });
    flkty.on('change', function () { active = null; if (last) update(last); });
  }

  /* ── Full-screen viewer (all devices) ─────────────────────────────────── */
  var viewer;
  function getViewer() {
    if (viewer) return viewer;
    var el = document.createElement('div');
    el.className = 'pp-zoom-viewer';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image zoom');
    el.hidden = true;
    el.innerHTML =
      '<div class="pp-zoom-viewer__stage"><img class="pp-zoom-viewer__img" alt="" draggable="false"></div>' +
      '<button type="button" class="pp-zoom-viewer__close" aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 4l12 12M16 4L4 16"/></svg>' +
      '</button>' +
      '<p class="pp-zoom-viewer__hint">Pinch or double-tap to zoom</p>';
    document.body.appendChild(el);

    var stage = el.querySelector('.pp-zoom-viewer__stage');
    var img = el.querySelector('.pp-zoom-viewer__img');
    var closeBtn = el.querySelector('.pp-zoom-viewer__close');
    var base = { w: 0, h: 0 }, s = 1, x = 0, y = 0, maxS = VIEW_MAX, natural = { w: 0, h: 0 };
    var pointers = {}, gesture = null, lastTap = null, returnFocus = null, currentHi = '', openedAt = 0;

    function vw() { return stage.clientWidth; }
    function vh() { return stage.clientHeight; }

    // Layout comes from the media's own dimensions, never from whichever copy
    // (low- or high-res) happens to be loaded, so the image never distorts.
    function fit() {
      var nw = natural.w || img.naturalWidth || 1, nh = natural.h || img.naturalHeight || nw;
      var k = Math.min(vw() / nw, vh() / nh, 1.5);
      base.w = nw * k; base.h = nh * k;
      img.style.width = base.w + 'px';
      img.style.height = base.h + 'px';
      maxS = clamp(nw / base.w * 1.5, 2, VIEW_MAX);
      s = 1; x = (vw() - base.w) / 2; y = (vh() - base.h) / 2;
      apply(false);
    }

    function bound() {
      var w = base.w * s, h = base.h * s;
      x = w <= vw() ? (vw() - w) / 2 : clamp(x, vw() - w, 0);
      y = h <= vh() ? (vh() - h) / 2 : clamp(y, vh() - h, 0);
    }

    function apply(animate) {
      img.classList.toggle('is-anim', !!animate);
      img.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + s + ')';
      el.classList.toggle('is-zoomed', s > 1.01);
    }

    function zoomAt(ns, px, py, animate) {
      ns = clamp(ns, 1, maxS);
      x = px - (px - x) * (ns / s);
      y = py - (py - y) * (ns / s);
      s = ns;
      bound();
      apply(animate);
    }

    function local(e) {
      var r = stage.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }

    function startGesture() {
      var ids = Object.keys(pointers);
      if (ids.length >= 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        gesture = { type: 'pinch', s: s, x: x, y: y,
          d: Math.hypot(a.x - b.x, a.y - b.y) || 1,
          mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
      } else if (ids.length === 1) {
        var p = pointers[ids[0]];
        gesture = { type: 'pan', x: x, y: y, px: p.x, py: p.y, sx: p.x, sy: p.y, moved: false };
      } else {
        gesture = null;
      }
    }

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      stage.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = local(e);
      startGesture();
      e.preventDefault();
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId] || !gesture) return;
      pointers[e.pointerId] = local(e);
      var ids = Object.keys(pointers);
      if (gesture.type === 'pinch' && ids.length >= 2) {
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var ns = clamp(gesture.s * Math.hypot(a.x - b.x, a.y - b.y) / gesture.d, 1, maxS);
        var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        x = mx - (gesture.mx - gesture.x) * (ns / gesture.s);
        y = my - (gesture.my - gesture.y) * (ns / gesture.s);
        s = ns;
        bound();
        apply(false);
      } else if (gesture.type === 'pan') {
        var p = pointers[e.pointerId];
        if (Math.abs(p.x - gesture.sx) + Math.abs(p.y - gesture.sy) > 8) gesture.moved = true;
        if (s > 1) {
          x = gesture.x + (p.x - gesture.px);
          y = gesture.y + (p.y - gesture.py);
          bound();
          apply(false);
        }
      }
    });

    function pointerEnd(e) {
      if (!pointers[e.pointerId]) return;
      var p = pointers[e.pointerId];
      var wasTap = gesture && gesture.type === 'pan' && !gesture.moved && Object.keys(pointers).length === 1;
      var wasPinch = gesture && gesture.type === 'pinch';
      delete pointers[e.pointerId];
      startGesture();                        // pinch → pan hand-off keeps the image steady
      if (wasPinch && gesture) gesture.moved = true;   // lifting the last pinch finger is not a tap
      if (!wasTap || e.type === 'pointercancel') return;

      // Hit-test against the drawn image: pointer capture makes e.target the stage.
      var onImg = p.x >= x && p.x <= x + base.w * s && p.y >= y && p.y <= y + base.h * s;
      if (e.pointerType === 'mouse') {
        // Mouse: a click on the image toggles zoom; a click on the backdrop closes.
        if (onImg) zoomAt(s > 1.01 ? 1 : VIEW_TAP, p.x, p.y, true);
        else if (s <= 1.01) close();
        return;
      }
      // Touch: double-tap toggles zoom; a single tap on the backdrop closes.
      var now = Date.now();
      if (lastTap && now - lastTap.t < 300 && Math.abs(p.x - lastTap.x) + Math.abs(p.y - lastTap.y) < 40) {
        clearTimeout(lastTap.timer);
        lastTap = null;
        zoomAt(s > 1.01 ? 1 : VIEW_TAP, p.x, p.y, true);
        return;
      }
      var tap = { t: now, x: p.x, y: p.y };
      if (!onImg && s <= 1.01) tap.timer = setTimeout(close, 300);
      lastTap = tap;
    }
    stage.addEventListener('pointerup', pointerEnd);
    stage.addEventListener('pointercancel', pointerEnd);

    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var p = local(e);
      zoomAt(s * Math.exp(-e.deltaY * 0.002), p.x, p.y, false);
    }, { passive: false });

    // Ignore the click a touch tap fires right after it opened the viewer.
    closeBtn.addEventListener('click', function () { if (Date.now() - openedAt > 400) close(); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') { e.preventDefault(); closeBtn.focus(); }
    });
    window.addEventListener('resize', function () { if (!el.hidden) fit(); });

    function close() {
      if (el.hidden) return;
      el.hidden = true;
      if (lastTap) clearTimeout(lastTap.timer);
      pointers = {}; gesture = null; lastTap = null;
      document.documentElement.classList.remove('pp-zoom-lock');
      if (returnFocus && returnFocus.focus) returnFocus.focus({ preventScroll: true });
    }

    viewer = {
      open: function (src, hi, alt, w, h) {
        returnFocus = document.activeElement;
        openedAt = Date.now();
        currentHi = hi;
        natural = { w: w || 0, h: h || 0 };
        img.alt = alt || '';
        img.src = src;
        // Re-append so late-loading widgets (chat / rewards launchers) can't sit on top.
        document.body.appendChild(el);
        el.hidden = false;
        document.documentElement.classList.add('pp-zoom-lock');
        closeBtn.focus({ preventScroll: true });
        fit();
        // Swap in the high-res copy; the box is already sized, so nothing moves.
        loadHiRes(hi, function () { if (!el.hidden && currentHi === hi) img.src = hi; });
      }
    };
    return viewer;
  }

  function openViewer(img) {
    var w = parseFloat(img.getAttribute('data-zoom-width')) || 0;
    var ratio = (parseFloat(img.getAttribute('height')) || 1) / (parseFloat(img.getAttribute('width')) || 1);
    getViewer().open(img.currentSrc || img.src, img.getAttribute('data-zoom-src'), img.alt, w, w * ratio);
  }

  window.ppZoom = function (root, galleryEl, flkty) {
    if (!galleryEl || !flkty || galleryEl.dataset.zoomBound) return;
    galleryEl.dataset.zoomBound = '1';

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) bindHover(root, galleryEl, flkty);

    // Tap / click (not a swipe) on the selected slide opens the viewer. Flickity
    // only emits staticClick while draggable, i.e. with more than one slide.
    if (flkty.isDraggable) {
      flkty.on('staticClick', function (event, pointer, cellEl) {
        var img = cellEl && cellEl === flkty.selectedElement && cellEl.querySelector('img[data-zoom-src]');
        if (img) openViewer(img);
      });
    } else {
      galleryEl.addEventListener('click', function (e) {
        var img = e.target.closest && e.target.closest('img[data-zoom-src]');
        if (img) openViewer(img);
      });
    }

    var btn = root.querySelector('[data-pp-zoom-open]');
    if (btn) {
      var sync = function () { btn.hidden = !(flkty.selectedElement && flkty.selectedElement.querySelector('img[data-zoom-src]')); };
      btn.addEventListener('click', function () {
        var img = flkty.selectedElement && flkty.selectedElement.querySelector('img[data-zoom-src]');
        if (img) openViewer(img);
      });
      flkty.on('change', sync);
      sync();
    }
  };
})();
